import { Input, } from "@chakra-ui/react";
import styled from "styled-components";

type Props = {
    type?:'text'|'password'|'number'|'submit'|'email';
    // className?: string;
    value?: string|number;
    // placeholder?: string;
    // onChange: (e:React.ChangeEvent<HTMLInputElement>) => void;
    // onKeyDown?: (e:React.KeyboardEvent<HTMLInputElement>) => void;
    // checked?: boolean;
    // disabled?: boolean;
    // max?: number;
    // min?: number;
    name: string,
    register: any;
    readOnly?: boolean;
    require?: boolean;

  }
export default function SInput(props: Props) {

    return (
        <Input 
            id={props.name}
            type={props.type}
            value={props.value}
            height={41} 
            borderRadius={0} 
            borderColor='brand.inputGrey' 
            _hover={{borderColor:'brand.inputGrey'}}
            focusBorderColor='brand.inputGrey'
            {...props.register(props.name, { required: props.require })}
            readOnly={props.readOnly}
        />
      );
}
